import React from 'react';
import styles from './index.module.scss';

import ssImage from 'assets/ss-icons/shipstation-icon.png';

export default function SSRLoggedOut() {
  return (
    <div className={styles.container}>
      <img className={styles.ssImage} src={ssImage} alt="ShipStation" />
      <span className={styles.errorTitle}>Something went wrong</span>
      <span className={styles.content}>
        We were unable to provision access. Please try again.
      </span>
    </div>
  );
}
